enum ApplicationFeature {
  ModelFilters = 'modelFilters',
  CustomerAddress = 'customerAddress',
  CustomerBusinessInfo = 'customerBusinessInfo',
  CustomerPhone = 'customerPhone',
  TradeIn = 'tradeIn',
  BookTestDrive = 'bookTestDrive',
  RequestOffer = 'requestOffer',
  ShareLink = 'shareLink',
}

export default ApplicationFeature;
